import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './en.json';
import arTranslations from './ar.json';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: localStorage.getItem('lang') || 'en',
  resources: {
    en: {
      translations: enTranslations,
    },
    ar: {
      translations: arTranslations,
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false,
  },
});

i18n.languages = ['en', 'ar'];

export default i18n;
